<template>
    <PageGroup>
        <router-view />
    </PageGroup>
</template>

<script>
    import PageGroup from 'source/components/_generics/layouts/PageGroup.vue';

    export default {
        name: 'OverviewPageGroup',

        components: {
            PageGroup,
        }
    };
</script>

<style lang="scss" scoped>
    @import 'source/stylesheets/sass/abstract/bpo-variables.scss';

    .page-group {
        grid-template-columns: 1fr;
    }
</style>
